import React, { useState } from "react";

export default function WorkDetailsStep({ setCurrentStep, selectedOffer }) {
  const [formData, setFormData] = useState({
    workEmail: "",
    designation: "",
    addressLine1: "",
    addressLine2: "",
    pincode: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    console.log("Saving Work Details:", formData);
    // Move to the next step (e.g., Aadhaar Verification)
    setCurrentStep(9); 
  };

  const lenderName = selectedOffer?.lender_name || "L&T Finance";

  return (
    <div className="w-full max-w-[400px] mx-auto bg-white min-h-[100dvh] font-atkinson flex flex-col relative pb-[120px]">
      
      {/* Header & Progress Bar */}
      <div className="px-5 pt-6 pb-4 border-b border-transparent">
        <div className="flex justify-center mb-4">
          <div className="text-center leading-none">
            <h1 className="text-[#205A6D] font-bold text-[22px] tracking-tight">
              {lenderName}
            </h1>
            <p className="text-[#7ea4b1] text-[10px] font-bold tracking-widest mt-1.5 uppercase">Application Process</p>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <button 
            onClick={() => setCurrentStep(7)} // Back to "Complete Application" checklist
            className="w-6 h-6 flex items-center justify-start text-gray-700 hover:opacity-70 transition-opacity"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
          </button>
          <div className="flex-1 mx-4 h-[5px] bg-[#E8F6EF] rounded-full overflow-hidden">
            <div className="h-full bg-[#00C676] w-[20%] rounded-full transition-all duration-500"></div>
          </div>
          <span className="text-[12px] text-[#8b8b8b] font-semibold">20%</span>
        </div>
      </div>

      <div className="px-5 pt-2 flex-1">
        <h2 className="text-[22px] font-semibold text-[#1b1b1b] tracking-tight">Work details</h2>
        
        {/* 👉 THE FIX: Added mb-6 here to create that perfect gap before the first input */}
        <p className="text-[13px] text-[#979797] font-normal leading-relaxed mt-1.5 mb-6 pr-2">
          Please enter your employment details to complete the verification for {lenderName}.
        </p>

        {/* Input Fields - Styled sleekly to match the Aadhaar page */}
        <div className="flex flex-col gap-4 animate-in fade-in slide-in-from-top-4 duration-500">
          
          <div className="border border-[#e6e6e6] rounded-[14px] w-full px-4 pt-2.5 pb-2.5 bg-white focus-within:border-black transition-colors duration-300">
            <label className="text-[11px] text-[#8b8b8b] block mb-[2px] font-medium">Enter Work Email</label>
            <input
              type="email"
              name="workEmail"
              placeholder="e.g. user@company.com"
              className="w-full outline-none text-[15px] text-[#1b1b1b] bg-transparent placeholder-[#cccccc] font-medium"
              value={formData.workEmail}
              onChange={handleChange}
            />
          </div>

          <div className="border border-[#e6e6e6] rounded-[14px] w-full px-4 pt-2.5 pb-2.5 bg-white focus-within:border-black transition-colors duration-300">
            <label className="text-[11px] text-[#8b8b8b] block mb-[2px] font-medium">Designation</label>
            <input
              type="text"
              name="designation"
              placeholder="e.g. Senior manager"
              className="w-full outline-none text-[15px] text-[#1b1b1b] bg-transparent placeholder-[#cccccc] font-medium"
              value={formData.designation}
              onChange={handleChange}
            />
          </div>

          <div className="border border-[#e6e6e6] rounded-[14px] w-full px-4 pt-2.5 pb-2.5 bg-white focus-within:border-black transition-colors duration-300">
            <label className="text-[11px] text-[#8b8b8b] block mb-[2px] font-medium">Address Line 1</label>
            <input
              type="text"
              name="addressLine1"
              placeholder="Building no., floor, street name"
              className="w-full outline-none text-[15px] text-[#1b1b1b] bg-transparent placeholder-[#cccccc] font-medium"
              value={formData.addressLine1}
              onChange={handleChange}
            />
          </div>

          <div className="border border-[#e6e6e6] rounded-[14px] w-full px-4 pt-2.5 pb-2.5 bg-white focus-within:border-black transition-colors duration-300">
            <label className="text-[11px] text-[#8b8b8b] block mb-[2px] font-medium">Address-Line 2 (optional)</label>
            <input
              type="text"
              name="addressLine2"
              placeholder="Landmark, area"
              className="w-full outline-none text-[15px] text-[#1b1b1b] bg-transparent placeholder-[#cccccc] font-medium"
              value={formData.addressLine2}
              onChange={handleChange}
            />
          </div>

          <div className="border border-[#e6e6e6] rounded-[14px] w-full px-4 pt-2.5 pb-2.5 bg-white focus-within:border-black transition-colors duration-300">
            <label className="text-[11px] text-[#8b8b8b] block mb-[2px] font-medium">Office Pincode</label>
            <input
              type="text"
              name="pincode"
              inputMode="numeric"
              maxLength="6"
              placeholder="e.g. 400001"
              className="w-full outline-none text-[15px] text-[#1b1b1b] bg-transparent placeholder-[#cccccc] font-medium"
              value={formData.pincode}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                setFormData({ ...formData, pincode: val });
              }}
            />
          </div>

        </div>
      </div>

      {/* Sticky Bottom Button */}
      <div className="fixed bottom-0 left-0 right-0 z-50 mx-auto w-full max-w-[400px] bg-gradient-to-t from-white via-white to-transparent px-5 pt-8 pb-5">
        <button
          onClick={handleSubmit}
          disabled={!formData.workEmail || !formData.designation || !formData.addressLine1 || formData.pincode.length !== 6}
          className="w-full bg-black text-white font-bold text-[17px] rounded-[16px] py-[18px] active:scale-[0.98] transition-transform disabled:opacity-30 disabled:cursor-not-allowed shadow-lg shadow-black/10"
        >
          Save & Continue
        </button>
      </div>
    </div>
  );
}